export default __webpack_public_path__ + "static/media/lomoIcon1-darkComplete.f2a9ccfe.svg";